import React, { useEffect, useState } from 'react';

import '../styles/Homepage.css';
import '../styles/Company.css';

import QuotesIcon from '../website_images/Icons/quotesIcon.png';
import ContactPhoto from '../website_images/Fotos/personal_photo.png';
import VoteraLogo from '../website_images/Logos/votera_logo.png';
import IsihomeLogo from '../website_images/Logos/isihome_logo.png';
import SchaarLogo from '../website_images/Logos/schaar_logo.png';
import { AnimatePresence, motion } from 'framer-motion';
import TileCard from '../components/TileCard';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ScrollAnimation from '../components/ScrollAnimation';
import OrganisationImage from '../website_images/Fotos/organisation.png'
import DOMPurify from 'dompurify';

const Company: React.FC = () => {
  const { t } = useTranslation();
  const [currentSlide, setCurrentSlide] = useState(0);
  const tileSets = [
    [
      {
        id: 1,
        title: t('companyFocused'),
        description: t('companyFocusedDesc'),
      },
      {
        id: 2,
        title: t('companyHolistic'),
        description: t('companyHolisticDesc'),
      },
      {
        id: 3,
        title: t('companyPartnership'),
        description: t('companyPartnershipDesc'),
      }
    ]];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % tileSets.length);
    }, 8000);
    return () => clearInterval(timer);
  }, [tileSets.length]);

  return (
    <div className="container company">
      <section className="company-header page-hero" id="page-hero" />
      <section className="main-section fullbleed">
        <ScrollAnimation animation="fadeInUp" delay={0.1}>
          <div className="company-inner" id="mission">
            <h1>{t('companyMissionH1')}</h1>
            <h2>{t('companyMissionH2')}</h2>
            <p>
              {t('companyMissionP')}
            </p>
          </div>
        </ScrollAnimation>
      </section>

      <section className="section-investmentProducts fullbleed">
        <ScrollAnimation animation="fadeInUp" delay={0.1}>
          <div className="slider-section" id="brand">
            <h1>{t('companyBrandH1')}</h1>
            <h2>{t('companyBrandH2')}</h2>

            <section className="hero-section">
              <div className="slider-container company-slider">
                <AnimatePresence mode="wait">
                  <motion.div
                    key={currentSlide}
                    className="tiles-slide"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="tiles-grid">
                      {tileSets[currentSlide].map((tile, index) => (
                        <div
                          key={tile.id}
                          className="tile company-tile"
                        >
                          <div className="company-tile-content">
                            <h3 className="tile-title">
                              {tile.title}
                            </h3>
                            <p className="tile-description-homepage">
                              {tile.description}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </motion.div>
                </AnimatePresence>
              </div>
            </section>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animation="fadeInUp" delay={0.1}>
          <div className="company-inner company-org" id="network">
            <h1>{t('companySIIGroupH1')}</h1>
            <div className='schaar-tilecard'>
              <TileCard
                image={SchaarLogo}
                title={t('companySchaarTitle')}
                description={t('companySchaarDesc')}
              />
            </div>
            <hr className='horizontal-first' />
            <hr className='horizontal-second' />
            <div className='tiles-container'>
              <TileCard
                image={VoteraLogo}
                title={t('companyVoteraTitle')}
                description={t('companyVoteraDesc')}
              />
              <hr className='horizontal-third' />
              <TileCard
                image={IsihomeLogo}
                title={t('companyIsihomeTitle')}
                description={t('companyIsihomeDesc')}
              />
            </div>
          </div>
        </ScrollAnimation>

      </section>

      <section className="main-section">
        <ScrollAnimation animation="fadeInUp" delay={0.1}>
          <div id="team">
            <h1>{t('companyCompetenceH1')}</h1>
            <h2>{t('companyCompetenceH2')}</h2>
            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('companyCompetenceP')) }}></p>
          </div>
        </ScrollAnimation>
      </section>
    </div >
  );
};

export default Company;
